<template>
	<el-dialog title="jjj" :visible.sync="dialogVisible" width="314px" class="closedProp" :close-on-click-modal="false">
		<div>
			<div class="textR"> <img src="../../assets/img/tanchuang/guanbi.png" alt="" @click.stop="close"></div>
			<div class="textC">
				<i class="el-icon-loading iconF"></i>
				<!-- <img class="turn" src="../../assets/img/tanchuang/icon-1.png" alt=""> -->
			</div>
            <div class="textMa">
				{{tips2}}
			</div>
		</div>
	</el-dialog>
</template>

<script>
	export default {
		name: 'ReportLoading',
		props: {
			tips: {
				type: String,
				default: '文件报告中'
			}
		},
		data() {
			return {
				dialogVisible: false,
				tips2: '文件报告中,请稍等片刻',
			}
		},
		methods: {
			show(str) {
				if (str) {
					this.tips2 = str
				}
				this.dialogVisible = true
			},
			close() {
				this.dialogVisible = false
			}
		},
		watch: {
			dialogVisible: {
				handler: function(val, oldval) {
					if (val) {
						// setTimeout(()=>{
						// 	this.dialogVisible = false
						// },2000)
					}
				},
				deep: true //对象内部的属性监听，也叫深度监听
			}
		}
	}
</script>

<style lang="less">
	.closedProp {

		// background-color: #fff;
		.el-dialog__header {
			display: none;
		}

		.el-dialog {
			background-color: #000000;
			opacity: 0.8;
		}

		.el-dialog__body {
			font-family: MicrosoftYaHei;
				font-size: 14px;
				font-weight: normal;
				font-stretch: normal;
				letter-spacing: 1px;
				color: #ffffff;
			text-align: center;
		}

		.el-dialog .el-dialog__body {
			padding: 12px;
		}
        .textMa{
			margin: 0px 30px 60px 30px;
			
		}
		.iconF{
			font-size: 90px;
			color: #75c3ff;
			margin: 10px;
		}
		.turn {
			// width: 100px;
			// height: 100px;
			// background: aqua;
			animation: turn 1s linear infinite;
			// margin: 100px auto;
			margin: 10px;
		}

		@keyframes turn {
			0% {
				-webkit-transform: rotate(0deg);
			}

			25% {
				-webkit-transform: rotate(90deg);
			}

			50% {
				-webkit-transform: rotate(180deg);
			}

			75% {
				-webkit-transform: rotate(270deg);
			}

			100% {
				-webkit-transform: rotate(360deg);
			}
		}
	}
</style>
